// removed by extract-text-webpack-plugin
module.exports = {"root":"_2hd2gK_"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Header/components/SignInRegister/SignInRegister.less
 ** module id = 733
 ** module chunks = 0
 **/